import React from "react";
import { Form, Label, FormGroup } from "reactstrap";
import PropTypes from "prop-types";
import { SelectFormField, FormField } from "../../../../../utils/FormFields";

const KYCConstants = {
  StockMarketKnowledge: {
    Nothing: "Nothing",
    Good: "Good",
    Expert: "Expert",
  },
  CustomerLink: {
    Option1: "Cliente Existente",
    Option2: "Referido por otro cliente",
    Option3: "Referido por AF/Director",
    Option4: "Fue cliente en el pasado de una empresa fusionada/Nobilis",
    Option5: "Sin conocimiento previo",
    Option6: "Sucesion de otra cuenta Nobilis",
  },
  CustomerRelatedSince: {
    NewCustomer: "New Customer",
    LessThan3: "Less than 3",
    Between3And10: "Between 3 and 10",
    MoreThan10: "More than 10",
  },
};

const InvestmentProfileTab = ({ account, changedAccount, showChanges }) => {
  const editKYC = {};
  Object.keys(changedAccount.KYC).map((key) => {
    if (changedAccount.KYC[key] !== account.KYC[key]) {
      editKYC[key] = changedAccount.KYC[key];
    }
    return {};
  });
  const compareKYC = {};
  Object.keys(editKYC).map((key) => {
    compareKYC[key] = account.KYC[key];
    return {};
  });
  return (
    <Form>
      <Label style={{ fontWeight: 500, fontSize: "20px", display: "block" }}>
        {showChanges ? "New changes" : "Actual Account"}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          <FormToShow KYC={editKYC} refKYC={compareKYC} />
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          <FormToShow KYC={compareKYC} />
        </FormGroup>
      )}
    </Form>
  );
};

InvestmentProfileTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default InvestmentProfileTab;

const FormToShow = ({ KYC, refKYC }) => (
  <React.Fragment>
    {KYC.AccountKnowledgeStockMarket && (
      <SelectFormField
        label="Stock Market Knowledge: "
        changedColor={refKYC && KYC.AccountKnowledgeStockMarket !== refKYC.AccountKnowledgeStockMarket}
        selectItems={Object.keys(KYCConstants.StockMarketKnowledge)}
        value={KYC.AccountKnowledgeStockMarket}
        getSelectItemId={(i) => KYCConstants.StockMarketKnowledge[i]}
        getSelectItemName={(i) => KYCConstants.StockMarketKnowledge[i]}
        name=""
      />
    )}
    {KYC.AccountInvestBonds && (
      <FormField
        label="Invest Bonds: "
        changedColor={refKYC && KYC.AccountInvestBonds !== refKYC.AccountInvestBonds}
        value={KYC.AccountInvestBonds ? "Yes" : "No"}
        name=""
      />
    )}
    {KYC.AccountInvestStocks && (
      <FormField
        label="Invest Stocks: "
        changedColor={refKYC && KYC.AccountInvestStocks !== refKYC.AccountInvestStocks}
        value={KYC.AccountInvestStocks ? "Yes" : "No"}
        name=""
      />
    )}
    {KYC.AccountInvestFunds && (
      <FormField
        label="Invest Funds: "
        changedColor={refKYC && KYC.AccountInvestFunds !== refKYC.AccountInvestFunds}
        value={KYC.AccountInvestFunds ? "Yes" : "No"}
        name=""
      />
    )}
    {KYC.AccountInvestOthers && (
      <FormField
        label="Invest Others: "
        changedColor={refKYC && KYC.AccountInvestOthers !== refKYC.AccountInvestOthers}
        value={KYC.AccountInvestOthers ? "Yes" : "No"}
        name=""
      />
    )}
    {KYC.AccountKYCCustomerLink && (
      <SelectFormField
        label="Customer Link: "
        changedColor={refKYC && KYC.AccountKYCCustomerLink !== refKYC.AccountKYCCustomerLink}
        value={KYC.AccountKYCCustomerLink}
        selectItems={Object.keys(KYCConstants.CustomerLink)}
        getSelectItemId={(i) => i}
        getSelectItemName={(i) => KYCConstants.CustomerLink[i]}
      />
    )}
    {KYC.AccountKYCCustomerLinkSpecify && (
      <FormField
        label="Customer Link Specify: "
        changedColor={refKYC && KYC.AccountKYCCustomerLinkSpecify !== refKYC.AccountKYCCustomerLinkSpecify}
        value={KYC.AccountKYCCustomerLinkSpecify}
        name=""
      />
    )}
    {KYC.AccountKYCCustomerRelatedSince && (
      <SelectFormField
        label="Related Since: "
        changedColor={refKYC && KYC.AccountKYCCustomerRelatedSince !== refKYC.AccountKYCCustomerRelatedSince}
        selectItems={Object.keys(KYCConstants.CustomerRelatedSince)}
        getSelectItemId={(i) => KYCConstants.CustomerRelatedSince[i]}
        getSelectItemName={(i) => KYCConstants.CustomerRelatedSince[i]}
        name=""
      />
    )}
    {KYC.AccountKYCCustomerProfessionName && (
      <FormField
        label="Customer Profession: "
        changedColor={
          refKYC && KYC.AccountKYCCustomerProfessionName !== refKYC.AccountKYCCustomerProfessionName
        }
        value={KYC.AccountKYCCustomerProfessionName}
        name=""
      />
    )}
    {KYC.AccountKYCAnualIncome && (
      <FormField
        label="Anual Income: "
        changedColor={refKYC && KYC.AccountKYCAnualIncome !== refKYC.AccountKYCAnualIncome}
        value={KYC.AccountKYCAnualIncome}
        name=""
      />
    )}
    {KYC.AccountKYCEstimatedAmount && (
      <FormField
        label="Estimated Amount: "
        changedColor={refKYC && KYC.AccountKYCEstimatedAmount !== refKYC.AccountKYCEstimatedAmount}
        value={KYC.AccountKYCEstimatedAmount}
        name=""
      />
    )}
    {KYC.AccountKYCAmountMaximumCustody !== undefined && (
      <FormField
        label="Maximum Custody: "
        changedColor={refKYC && KYC.AccountKYCAmountMaximumCustody !== refKYC.AccountKYCAmountMaximumCustody}
        value={KYC.AccountKYCAmountMaximumCustody}
        name=""
      />
    )}
    {KYC.AccountKYCAmountDepositedStocks !== undefined && (
      <FormField
        label="Amount Deposited Assets: "
        changedColor={
          refKYC && KYC.AccountKYCAmountDepositedStocks !== refKYC.AccountKYCAmountDepositedStocks
        }
        value={KYC.AccountKYCAmountDepositedStocks}
        name=""
      />
    )}
    {KYC.AccountKYCAmountRetiredStocks !== undefined && (
      <FormField
        label="Amount Withdrawn Assets: "
        changedColor={refKYC && KYC.AccountKYCAmountRetiredStocks !== refKYC.AccountKYCAmountRetiredStocks}
        value={KYC.AccountKYCAmountRetiredStocks}
        name=""
      />
    )}
    {KYC.AccountKYCQuantityDepositedStocks !== undefined && (
      <FormField
        label="Quantity Deposited Assets: "
        changedColor={
          refKYC && KYC.AccountKYCQuantityDepositedStocks !== refKYC.AccountKYCQuantityDepositedStocks
        }
        value={KYC.AccountKYCQuantityDepositedStocks}
        name=""
      />
    )}
    {KYC.AccountKYCQuantityRetiredStocks !== undefined && (
      <FormField
        label="Quantity Withdrawn Assets: "
        changedColor={
          refKYC && KYC.AccountKYCQuantityRetiredStocks !== refKYC.AccountKYCQuantityRetiredStocks
        }
        value={KYC.AccountKYCQuantityRetiredStocks}
        name=""
      />
    )}
    {KYC.AccountKYCComments && (
      <FormField
        label="Coments: "
        changedColor={refKYC && KYC.AccountKYCComments !== refKYC.AccountKYCComments}
        value={KYC.AccountKYCComments}
        name=""
      />
    )}
    {KYC.AccountKYCManualHighRisk && (
      <FormField
        label="Manual High Risk: "
        changedColor={refKYC && KYC.AccountKYCManualHighRisk !== refKYC.AccountKYCManualHighRisk}
        value={KYC.AccountKYCManualHighRisk}
        name=""
      />
    )}
  </React.Fragment>
);

FormToShow.propTypes = {
  KYC: PropTypes.object.isRequired,
  refKYC: PropTypes.object,
};

FormToShow.defaultProps = {
  refKYC: undefined,
};
